<template>

  <div class="ui grid animated fadeIn">

    <div v-if="!showDifsRev" class="sixteen wide column">

      <div class="ui segment" style="min-height: 150px; padding: 20px !important;">

        <div v-if="quotation.revisions.length == 0" class="grey text">
          <i class="info circle icon"></i> Nenhuma revisão
        </div>

        <table v-else class="ui very basic selectable celled table">
          <thead class="desktop-only">
            <tr>
              <th>Revisão</th>
              <th>Evento</th>
              <th>Usuário</th>
              <th>Data</th>
              <th>Hora</th>
              <th v-if="!$isSeller()"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="revision in quotation.revisions" class="clickable" @click="onShow(revision)">                   
              <td><strong class="mobile-only">Revisão: </strong>{{ revision.revision }}</td>
              <td><strong class="mobile-only">Evento: </strong>{{ revision.eventDescription }}</td>
              <td><strong class="mobile-only">Usuário: </strong>{{ revision.nameUser }}</td>
              <td><strong class="mobile-only">Data: </strong>{{ $formatDate(revision.date) }}</td>
              <td><strong class="mobile-only">Hora: </strong>{{ revision.time }}</td>
              <td v-if="!$isSeller()">
                <button v-if="revision.eventDescription && revision.revision != '01'" class="ui mini basic button"
                  :class="{ loading: revision.revision == printingRevision }"
                  @click="compareRevision($event, revision)">
                  <i class="eye blue icon"></i>
                  Comparar
                </button>
              </td>
              <td v-if="!$isSeller()">
                <button v-if="revision.eventDescription" class="ui mini basic button" 
                  :class="{ loading: revision.revision == printingRevision }"
                  @click="onPrint($event, revision)">
                  <i class="print blue icon"></i>
                  Imprimir
                </button>
              </td>
            </tr>                
          </tbody>
        </table>

      </div>

    </div>

  </div>
</template>

<script>
  import QuotationService from "@/services/quotation-service"

  export default {

    data() {
      return {
        printingRevision: "",
      }
    },

    props: ["quotation"],

    methods: {

      async compareRevision($event, revision) {      
        $event.stopPropagation()
        if (this.printingRevision)
          return null

        this.printingRevision = revision.revision
        QuotationService.showDifQuotation(this.quotation.id, this.printingRevision)
        this.printingRevision = ""
      },

      onShow(revision) {
        QuotationService.showQuotation(this.quotation.id, revision.revision)
      },

      async onPrint($event, revision) {

        $event.stopPropagation()

        if (this.printingRevision)
          return

        this.printingRevision = revision.revision

        try {

          await QuotationService.print(this.quotation.id, this.printingRevision)

          this.printingRevision = ""
          
        } catch (error) {

          this.printingRevision = ""

          this.$errorHandler(error)          
        }
      },
    },
  }

</script>

